import { VerticalAlignType, HorizontalAlignType } from "common/constants";
import * as geom from "js/core/utilities/geom";

const layoutHelper = {};

layoutHelper.getHorizontalAlignOffset = function(itemWidth, containerWidth, align = HorizontalAlignType.CENTER) {
    switch (align) {
        case HorizontalAlignType.LEFT:
            return 0;
        case HorizontalAlignType.CENTER:
            return containerWidth / 2 - itemWidth / 2;
        case HorizontalAlignType.RIGHT:
            return containerWidth - itemWidth;
    }
};

layoutHelper.getVerticalAlignOffset = function(itemHeight, containerHeight, align = VerticalAlignType.TOP) {
    switch (align) {
        case VerticalAlignType.TOP:
            return 0;
        case VerticalAlignType.MIDDLE:
            return containerHeight / 2 - itemHeight / 2;
        case VerticalAlignType.BOTTOM:
            return containerHeight - itemHeight;
    }
};

layoutHelper.getAlignOffset = function(itemSize, containerSize, horizontalAlign = HorizontalAlignType.CENTER, verticalAlign = VerticalAlignType.MIDDLE) {
    return new geom.Point(layoutHelper.getHorizontalAlignOffset(itemSize.width, containerSize.width, horizontalAlign), layoutHelper.getVerticalAlignOffset(itemSize.height, containerSize.height, verticalAlign));
};

export { layoutHelper };
